import styled from "@emotion/styled";
import { TViolationRsvListItem } from "../../types";
import NoshowTableHeader from "../../../../../../../uis/MinimumAttendeesManagement/ViolationReservationHeader";
import UI from "@mile-meeting/mile-ui";
import ViolationReservationItem from "uis/MinimumAttendeesManagement/ViolationReservationItem";

const ViolationRsvListTable = ({ violationRsvList }: { violationRsvList: TViolationRsvListItem[] }) => {
  return (
    <TableContainer>
      <NoshowTableHeader />
      {violationRsvList.length > 0 &&
        violationRsvList.map((item, index) => <ViolationReservationItem key={index} violationRsvInfo={item} />)}
      {violationRsvList.length === 0 && (
        <EmptyContainer>
          <UI.Icon name="removeCircle" size={24} color="var(--alias-color-label-alternative)" />
          <UI.Typography type="body01 normal" fontStyle="regular" color="var(--alias-color-label-normal)">
            해당 조회 기간 내에 최소 참석 인원 제한을 위반한 예약이 없습니다.
          </UI.Typography>
        </EmptyContainer>
      )}
    </TableContainer>
  );
};

export default ViolationRsvListTable;

const TableContainer = styled.div`
  display: flex;
  min-width: 832px;
  flex-direction: column;
  align-items: flex-start;
  align-self: stretch;
`;

const EmptyContainer = styled.div`
  display: flex;
  min-width: 832px;
  padding: 12px 24px;
  align-items: center;
  align-self: stretch;
  gap: 8px;

  border-bottom: 1px solid var(--alias-color-line-normal);
`;
